// @ts-expect-error: no types yet in the library package
import tokens from '@nike/design-system-base';
import { DialogActionsStyled } from '@nike/nike-design-system-components';
import styled from '@emotion/styled';

const CookieDialogActionsStyled = styled(DialogActionsStyled)`
  padding: 24px 60px 36px;
  box-shadow: 0 -2px 6px 0 rgba(17, 17, 17, 0.28);

  @media only screen and (max-width: ${tokens.bp('tablet')}px) {
    padding: 24px;
  }

  .dialog-actions-decline-btn {
    margin-right: 0;

    @media only screen and (max-width: ${tokens.bp('tablet')}px) {
      margin-top: 12px;
    }
  }

  .dialog-actions-accept-btn {
    margin-left: 12px;

    @media only screen and (max-width: ${tokens.bp('tablet')}px) {
      margin-left: 0;
    }
  }
`;

export { CookieDialogActionsStyled };
